// src/directives/permission.js
import { usePermission } from '@/hooks/usePermission'

export default {
  mounted(el, binding) {
    const { hasPermission } = usePermission()

    const value = binding.value

    if (!hasPermission(value)) {
      // 无权限 → 移除节点
      el.parentNode && el.parentNode.removeChild(el)
    }
  }
}
